import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getDeadlineDate = async ({ documentTypeId, inputDate }) => {
  return await request.get(
    '/Docs/deadline_date',
    { documentTypeId, inputDate },
    'При получении срока ответа произошла ошибка'
  );
};

const useDeadlineDateQuery = (
  { documentTypeId, inputDate, showResponseTimeDoc },
  options
) =>
  useQuery(
    queryKeys.deadlineDate({ documentTypeId, inputDate, showResponseTimeDoc }),
    () => getDeadlineDate({ documentTypeId, inputDate }),
    options
  );

export default useDeadlineDateQuery;
